// extracted by mini-css-extract-plugin
export default {"body":"SortModalDesktop_body__jVQv7","option":"SortModalDesktop_option__RAiIx","sort":"SortModalDesktop_sort__9mVo6","sortBy":"SortModalDesktop_sortBy__FVyWS"};